import TeenScheduledGigsWorkspace from "../../../components/scheduled-gigs/TeenScheduledGigsWorkspace";

const TeenScheduledGigsPage = () => {
  return <TeenScheduledGigsWorkspace />;
};

export default TeenScheduledGigsPage;
